import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin(nuxtApp => {
  const router = useRouter()
  const config = useRuntimeConfig()

  if (!config.public.SENTRY_ENDPOINT) {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: config.public.SENTRY_ENDPOINT,
    environment: config.public.SENTRY_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: 0.2,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['dora.develop.vrify.com', 'dora.staging.vrify.com', 'dora.vrify.com'],

    replaysSessionSampleRate: 0.2, // Change in prod if necessary
    replaysOnErrorSampleRate: 1.0,
  })

  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    Sentry.captureException(error, { extra: { instance, info } })
  }
})
